import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
padding:4rem 2rem 0 2rem;
z-index: 100;
position: relative;

    @media only screen and (min-width: 450px) {
        padding:4rem 4rem 0 4rem;
    }
    @media only screen and (min-width: 1024px) {
        padding:8rem 10rem 0 10rem;
    }

`

export { Styling }